import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnFreezeFilterPipe } from './column-freeze-filter.pipe';



@NgModule({
  declarations: [ColumnFreezeFilterPipe],
  exports: [
    ColumnFreezeFilterPipe
  ],
  imports: [
    CommonModule
  ]
})
export class ColumnFreezeFilterModule{ }
